import { EnumLiteralsOf } from 'utilities'
import { Person, Project, Brand, Product, ProductTableEntryDTO, AgreementDTO } from 'models'

export enum WarningLevel {
  WARNING,
  ERROR
}

export const objectTypes = {
  project: 'project' as 'project',
  person: 'person' as 'person',
  product: 'product' as 'product',
  brand: 'brand' as 'brand',
  agreement: 'agreement' as 'agreement'
}
export type ObjectTypes = EnumLiteralsOf<typeof objectTypes>;

export interface Props {
  object: Project | ProductTableEntryDTO | Person | Product | Brand | AgreementDTO
  objectType: ObjectTypes
  agreementCol?: 'remainingBudget' | 'period'
}

export const imageWarnings = {
  missingImages: 'missingImages' as 'missingImages',
  missingImageWithPortraitCrop: 'missingImageWithPortraitCrop' as 'missingImageWithPortraitCrop',
  missingGeneralPortrait: 'missingGeneralPortrait' as 'missingGeneralPortrait',
  missingGeneralSquare: 'missingGeneralSquare' as 'missingGeneralSquare'
}
export type ImageWarningTypes = EnumLiteralsOf<typeof imageWarnings>

export const videoWarnings = {
  missingVideo: 'missingVideo' as 'missingVideo',
  videoNotProcessed: 'videoNotProcessed' as 'videoNotProcessed'
}
export type VideoWarningTypes = EnumLiteralsOf<typeof videoWarnings>

export const budgetWarnings = {
  lowBudget: 'lowBudget' as 'lowBudget',
  noRemainingBudget: 'noRemainingBudget' as 'noRemainingBudget'
}
export type BudgetWarningTypes = EnumLiteralsOf<typeof budgetWarnings>

export const periodWarnings = {
  periodAboutToExpire: 'periodAboutToExpire' as 'periodAboutToExpire',
  periodExpired: 'periodExpired' as 'periodExpired'
}
export type PeriodWarningTypes = EnumLiteralsOf<typeof periodWarnings>

export const warnings = {
  ...imageWarnings,
  ...videoWarnings,
  ...budgetWarnings,
  ...periodWarnings
}
export type WarningTypes = EnumLiteralsOf<typeof warnings>
